import React, { useContext, useEffect, useState } from "react";
import { ConfigContext } from "../../Context/ConfigContext";
import axios from "axios";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { ContentLoader, NoRecords } from "../../Components/Shimmer";
import { DateFormater } from "../GlobalFunctions";

const AssignedItems = () => {
  const { apiURL, user_id } = useContext(ConfigContext);
  const [loadingList, setLoadingList] = useState(true);
  const [projectselectedItems, setProjectselectedItems] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [usedQty, setUsedQty] = useState("");
  const { project_id } = useParams();

  const getUsedPercentage = (total, used) => {
    if (!total || total === 0) return 0;
    return Math.min(100, Math.round((used / total) * 100));
  };

  const getProjectItemList = async () => {
    try {
      setLoadingList(true);
      const response = await axios.get(`${apiURL}api/requests/GetProjectItems`, {
        params: { project_id }
      });

      const { data, success } = response.data;
      if (success) setProjectselectedItems(data || []);
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingList(false);
    }
  };

  const handleUseItem = (item) => {
    setSelectedItem(item);
    setUsedQty("");
    setShowModal(true);
  };

  const handleConfirmUse = async () => {
    if (!usedQty || isNaN(usedQty) || Number(usedQty) <= 0) {
      Swal.fire("Invalid Quantity", "Please enter a valid used quantity.", "warning");
      return;
    }

    const totalQty = Number(selectedItem?.pi_item_qty || 0);
    const currentUsed = Number(selectedItem?.pi_item_received_qty || 0);
    const remainingQty = totalQty - currentUsed;

    if (Number(usedQty) > remainingQty) {
      Swal.fire("Error", "Used qty is more than remaining quantity", "error");
      return;
    }

    const newUsedTotal = currentUsed + Number(usedQty);

    try {
      setShowModal(false);

      Swal.fire({
        title: "Confirm Use?",
        text: `You are using ${usedQty} of ${selectedItem?.item_name}.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const url = "https://tms.atctransline.in/apis/api/project-items/ReceivedItem";

          const formData = new URLSearchParams();
          formData.append("project_item_id", selectedItem?.project_item_id);
          formData.append("pi_item_received_qty", newUsedTotal);
          formData.append("received_by", user_id);

          const response = await axios.post(url, formData, {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          });

          const { success, message } = response.data;

          if (success) {
            Swal.fire("Success", message || "Item updated successfully!", "success");
            getProjectItemList();
          }
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getProjectItemList();
  }, []);

  return (
    <div className="col-xxl-12">
      <div className="card">
        <div className="card-body">
          <div className="card-header align-items-center d-flex">
            <h5 className="card-title flex-grow-1 mb-0">Items List</h5>
          </div>

          {loadingList ? (
            <ContentLoader />
          ) : projectselectedItems.length === 0 ? (
            <NoRecords />
          ) : (
            <div className="table-responsive table-card mt-3">
              <table className="table table-hover table-nowrap align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th>Item Name</th>
                    <th>Unit</th>
                    <th>Price</th>
                    <th>Delivery Date</th>
                    <th>Total Qty</th>
                    <th>Used Qty</th>
                    <th>Progress</th>
                    <th className="text-end">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {projectselectedItems.map((item) => {
                    const used = item?.pi_item_received_qty || 0;
                    const total = item?.pi_item_qty || 0;
                    const remaining = total - used;
                    const percentage = getUsedPercentage(total, used);

                    return (
                      <tr key={item?.item_id}>
                        <td>{item?.item_name || "-"}</td>
                        <td>{item?.item_unit || "-"}</td>
                        <td>{item?.pi_item_price || "-"} QAR</td>
                        <td>{DateFormater(item?.pi_item_delivery_date)}</td>
                        <td>{total || "-"}</td>
                        <td>
                          <span className="fw-semibold text-success">{used}</span> / {total}
                        </td>

                        <td style={{ width: "160px" }}>
                          <div className="progress" style={{ height: "6px" }}>
                            <div
                              className="progress-bar bg-success"
                              role="progressbar"
                              style={{ width: `${percentage}%` }}
                            ></div>
                          </div>
                          <small className="text-muted">{percentage}%</small>
                        </td>

                        <td className="text-end">
                          <button
                            type="button"
                            className="btn btn-success btn-sm"
                            onClick={() => handleUseItem(item)}
                            disabled={remaining <= 0}
                          >
                            {remaining <= 0 ? "Fully Used" : "Use Items"}
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* Use Item Modal */}
      {showModal && (
        <>
          <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Used Items</h5>
                  <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                </div>

                <div className="modal-body">
                  <p>
                    Enter used quantity for <strong>{selectedItem?.item_name}</strong>:
                  </p>

                  <input
                    type="number"
                    className="form-control"
                    value={usedQty}
                    onChange={(e) => setUsedQty(e.target.value)}
                    min="1"
                    max={
                      selectedItem
                        ? selectedItem.pi_item_qty - selectedItem.pi_item_received_qty
                        : 1
                    }
                    placeholder="Enter used quantity"
                  />
                </div>

                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                    Cancel
                  </button>

                  <button type="button" className="btn btn-success" onClick={handleConfirmUse}>
                    Confirm
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </div>
  );
};

export default AssignedItems;
